var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.099 37.483H18.907a4.614 4.614 0 01-4.614-4.614V15.69a4.614 4.614 0 014.614-4.614h12.374a4.614 4.614 0 014.614 4.614v17.449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.566 28.708a4.17 4.17 0 01-2.942-3.985V9.204a4.168 4.168 0 014.168-4.168H21.97c1.092 0 2.087.42 2.83 1.108M20.279 24.28h9.631M25.095 19.464v9.631"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_dot",
    d: "M26.539 24.28a1.444 1.444 0 11-2.888 0 1.444 1.444 0 012.888 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassCreate);
export default __webpack_public_path__ + "static/media/massCreate.7bdf553840b1ec1681755313574108b4.svg";
export { ForwardRef as ReactComponent };